<template>
    <div>

        <div :class="spinnerClass">
            <vue-simple-spinner
                :size="size"
                :text-fg-color="textFgColor"
                :font-size="fontSize"
                :spacing="spacing"
                :speed="speed"
                :line-size="lineSize"
                :line-fg-color="lineFgColor"
                :line-bg-color="lineBgColor"
                :message="message"></vue-simple-spinner>
        </div>

        <div :class="slotClass">
            <slot/>
        </div>

    </div>
</template>

<script>

    import BaseSpinner from 'vue-simple-spinner'

    export default {

        data() {
            return {
                message: this.msg, //'please be patient ...',
                lineSize: 5,
                size: '60',
                speed: 3,
                spacing: 20,
                fontSize: 15,
                lineFgColor: '#0071b9',
                lineBgColor: '#aaaaaa',
                textFgColor: '#0071b9',
                spinnerClass: 'is-not-loading',
                slotClass: ''
            }
        },

        components: { BaseSpinner },

        props: [
            'msg'
        ],

        methods: {
            changeState: function (onHold) {
                if(onHold){
                    this.spinnerClass='is-loading';
                    this.slotClass='is-not-loading'
                } else {
                    this.spinnerClass='is-not-loading';
                    this.slotClass=''
                }
            },
            startOnHold: function(){
                this.changeState(true);
            },
            stopOnHold: function(){
                this.changeState(false);
            }
        }

    }
</script>

<style scoped>
    .is-loading {
        width: 100%;
        height: 100%;
        display: block;
        margin-top:10%;
        z-index:10000;
    }
    .is-not-loading{
        display: none;
    }
</style>